var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19H5.5C4.0418 18.9984 2.64377 18.4184 1.61267 17.3873C0.581561 16.3562 0.00158817 14.9582 0 13.5L0 5.5C0.00158817 4.0418 0.581561 2.64377 1.61267 1.61267C2.64377 0.581561 4.0418 0.00158817 5.5 0L13.5 0C14.9582 0.00158817 16.3562 0.581561 17.3873 1.61267C18.4184 2.64377 18.9984 4.0418 19 5.5V13.5C18.9984 14.9582 18.4184 16.3562 17.3873 17.3873C16.3562 18.4184 14.9582 18.9984 13.5 19ZM5.5 3C4.83696 3 4.20107 3.26339 3.73223 3.73223C3.26339 4.20107 3 4.83696 3 5.5V13.5C3 14.163 3.26339 14.7989 3.73223 15.2678C4.20107 15.7366 4.83696 16 5.5 16H13.5C14.163 16 14.7989 15.7366 15.2678 15.2678C15.7366 14.7989 16 14.163 16 13.5V5.5C16 4.83696 15.7366 4.20107 15.2678 3.73223C14.7989 3.26339 14.163 3 13.5 3H5.5ZM24 18.5V7C24 6.60218 23.842 6.22064 23.5607 5.93934C23.2794 5.65804 22.8978 5.5 22.5 5.5C22.1022 5.5 21.7206 5.65804 21.4393 5.93934C21.158 6.22064 21 6.60218 21 7V18.5C21 19.163 20.7366 19.7989 20.2678 20.2678C19.7989 20.7366 19.163 21 18.5 21H7C6.60218 21 6.22064 21.158 5.93934 21.4393C5.65804 21.7206 5.5 22.1022 5.5 22.5C5.5 22.8978 5.65804 23.2794 5.93934 23.5607C6.22064 23.842 6.60218 24 7 24H18.5C19.9582 23.9984 21.3562 23.4184 22.3873 22.3873C23.4184 21.3562 23.9984 19.9582 24 18.5Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_1290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copyWhite.2dad1c3bc8a86a082ea50518a9e7789d.svg";
export { ForwardRef as ReactComponent };